<div class="text-center" ngbPopover="PERMISSION NEEDED" placement="bottom" triggers="mouseenter:mouseleave" container="body">
  <i class="fa fa-lock text-grey-med-color"></i>
</div>
